// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__2oJpi","frame":"Dialog_frame__2SGN6","closeButton":"Dialog_closeButton__BDI4v","okButton":"Dialog_okButton__3St7_","body":"Dialog_body__wfRjZ"};